<template>
    <el-dialog
        title="单据补打"
        width="400px"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'repeatPrintReason'"
        >
        <el-form ref="form" :model="form" :rules="rules" label-width="90px">
            <div style="color: red" v-if="tooltip">{{ tooltip }}</div>
            <el-form-item label="补打原因：" prop="reason">
                <otpSelect
                    :optionNum="'REPEAT_PRINT_REASON'"
                    @getSelectValue="getSelectValue"
                    :mValue="form.reason"
                    placeholder="请选择补打原因"
                    :prop="'reason'"
                >
                </otpSelect>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input
                    v-model.trim="form.remark"
                    type="textarea"
                    autosize
                    placeholder="请备注补打原因"
                    maxlength="100"
                    show-word-limit
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit">确 认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import otpSelect from '@/components/lots/otpSelect';
export default {
    name: 'DispatchRepeatPrint',
    components: { otpSelect },
    props: {
        componentsData: {
            type: [Array, Object]
        },
        tooltip: {
            type: String,
            default () {
                return '';
            }
        }
    },
    data () {
        return {
            btnLoading: false,
            form: {
                reason: '',
                remark: ''
            },
            rules: {
                reason: [
                    {
                        required: true,
                        message: '请选择补打原因',
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    methods: {
        /**
         * @description: 高级下拉选中的回调
         * @param {*} data 选中的数据
         * @return {*}
         */
        getSelectValue (data) {
            this.form.reason = data.reason || '';
        },
        /**
         * @description 关闭
         */
        beforeClose () {
            this.$emit('update:isShowPrintReasonDialog', false);
        },
        /**
         * @description 提交
         */
        handleSubmit () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$emit('update:isShowPrintReasonDialog', false);
                    this.$emit('handlePrint', this.componentsData, this.form);
                };
            });
        }
    }
};
</script>

<style lang="less">
.repeatPrintReason{
    .el-dialog__body {
        padding: 16px 26px 16px 16px;
    }
}
</style>
